import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import CollectionOverview from '../components/collection-overview';
import SystemOverview from '../../system/system-overview';

import { switchCollectionTabs } from '../actions/collection-action-creators';
import { switchSideNavItems } from '../../common/actions/ui-state-action-creators';

import { selectedCollectionTabIdSelector, selectedCollectionWithCanvasesSelector } from '../selectors/collection-selectors';
import { selectedSideNavItemIdSelector } from '../../common/selectors/ui-state-selectors';

export class CollectionOverviewContainer extends Component{
    componentDidMount(){
        const { activeCollectionTabId, activeSideNavItemId, collection: { id } } = this.props;
        if( activeCollectionTabId === null ){
            this.props.switchSideNavItems( id );
        }

        if( activeCollectionTabId !== activeSideNavItemId ){
            this.props.switchCollectionTabs( id );
        }
    }

    componentDidUpdate(){
        const { activeCollectionTabId, activeSideNavItemId, collection: { id } } = this.props;

        if( activeCollectionTabId !== activeSideNavItemId ){
            this.props.switchCollectionTabs( id );
        }
    }

    render(){
        const { collection, match } = this.props;
        if( get( match, 'params.collectionId', null ) === 'system' ){
            return <SystemOverview match={match} />;
        }

        return (
            <CollectionOverview collection={collection} match={match} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => {
    return {
        activeCollectionTabId: selectedCollectionTabIdSelector( state, props ),
        activeSideNavItemId: selectedSideNavItemIdSelector( state, props ),
        collection: selectedCollectionWithCanvasesSelector( state, props )
    };
};

CollectionOverviewContainer.propTypes = {
    activeCollectionTabId: PropTypes.oneOfType( [
        PropTypes.number,
        PropTypes.string
    ] ),
    activeSideNavItemId: PropTypes.oneOfType( [
        PropTypes.number,
        PropTypes.string
    ] ),
    collection: PropTypes.shape( {
        id: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number] )
    } ).isRequired,
    match: PropTypes.object.isRequired,
    switchCollectionTabs: PropTypes.func.isRequired,
    switchSideNavItems: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { switchCollectionTabs, switchSideNavItems } )( CollectionOverviewContainer );
